const bar = document.getElementById('omt-sticky-bar');
const target = document.querySelector('.pdp-buy-row');

if (bar && target) {
  bar.hidden = false;
  const observer = new IntersectionObserver(
    (entries) => {
      bar.classList.toggle('on', !entries[0].isIntersecting);
    },
    { rootMargin: '-120px 0px 0px 0px' }
  );
  observer.observe(target);
}
